

<div class="table-responsive margin-top-15 table-view">
    <h5 class="table-title">POB Roster</h5>
    <button class="btn btn-primary primary-btn button-excel"  style="margin-bottom: 10px;" (click)="exportToExcel()">
      <i class="fa fa-file-excel-o"></i>Export To Excel</button>
    <p-table [columns]="cols" [value]="rows" [scrollable]="false" scrollHeight="500px" dataKey="Id" editMode="row" id="POBRosterTableToExport">
      <ng-template pTemplate="header" let-columns>
          <tr>
              <th [ngClass]="col.header =='Unit Name' ? '':'center-table'" style="width: 150px;" *ngFor="let col of columns">
                <span *ngIf="col.header !='IncidentId'">{{col.header}}</span>   
              </th> 
              <!-- <th class="center-table" style="width: 60px;">Actions</th> -->
            
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-ri="rowIndex" let-editing="editing">
          <tr [pEditableRow]="rowData">
              <td [ngClass]="col.field == 1 ? '':'center-table'" style="width: 150px;" *ngFor="let col of columns">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input *ngIf="col.field != 0 && col.field != 1"
                      pInputText
                      type="number"
                      [(ngModel)]="rowData[col.field]"
                      required
                    />
                    <span *ngIf="col.field == 1">{{rowData[col.field]}}</span>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <!-- <a *ngIf="col.field != 0 && col.field != 1 && col.header !='Compliance(%)'" data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                    (click)="GetIncidentRegisterSelectedDetails(rowData,col)" data-target="#AT"> {{rowData[col.field]}}</a>                                               -->
                    <span>{{rowData[col.field]}}</span>       
                  </ng-template>
                </p-cellEditor>
              </td>
              <!-- <td class="center-table" style="width: 80px;" *ngIf="rowData[0] != 'Total'">

                <button
                  *ngIf="!editing"
                  pButton
                  pRipple
                  type="button"
                  pInitEditableRow
                  icon="pi pi-pencil"
                  (click)="onRowEditInit(rowData)"
                  class="p-button-rounded p-button-text"
                ></button>
                <button
                  *ngIf="editing"
                  pButton
                  pRipple
                  type="button"
                  pSaveEditableRow
                  icon="pi pi-check"
                  (click)="onRowEditSave(rowData,ri)"
                  class="p-button-rounded p-button-text p-button-success p-mr-2"
                ></button>
                <button
                  *ngIf="editing"
                  pButton
                  pRipple
                  type="button"
                  pCancelEditableRow
                  icon="pi pi-times"
                  (click)="onRowEditCancel(rowData,ri)"
                  class="p-button-rounded p-button-text p-button-danger"
                ></button>
              </td> -->
          </tr>
      </ng-template>
  </p-table>
</div>

<div class="modal fade PDModal" data-backdrop="static" style="opacity:1 !important;" id="AT" role="dialog">
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        
          <button type="button" class="close button-cancel" data-dismiss="modal">&times;</button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">
        <!-- <img class="ram-img" src="assets/images/incident-ram.png" /> -->
        <ol id="liPDheight">
          <ng-container *ngFor="let item of RosterData; let i=index">
            <li><a (click)="Redirect(item.value,item.ID)">{{item.Text }}</a></li>
         </ng-container>   
        </ol>
        <span *ngIf="RosterData?.length < 1" style="color:red;">No Records Found..</span>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
